import { useEffect, useState } from 'react'
import { InlineEditable, InlineEditableProps } from '@integration-app/react'
import clsx from 'clsx'

import classes from './Field.module.css'

interface EditableFieldKeyProps extends InlineEditableProps {
  onChange: (name: string) => void
  deprecatedNames?: string[]
}

export function FieldKeyEditable({
  value,
  onChange,
  deprecatedNames = [],
  ...props
}: EditableFieldKeyProps) {
  const [isInvalid, setIsInvalid] = useState(false)
  const [localValue, setLocalValue] = useState(value)
  const [dirtyInput, setDirtyInput] = useState(false)

  // Watch outer value changes and update local state
  // only if input is not dirty
  useEffect(() => {
    if (!dirtyInput) {
      setLocalValue(value)
    }
  }, [value, dirtyInput])

  function handleChange(name: string) {
    setLocalValue(name)
    setDirtyInput(true)
    if (deprecatedNames?.includes(name)) {
      setIsInvalid(true)
      return
    }
    setIsInvalid(false)
    setDirtyInput(false)
    onChange?.(name)
  }

  function handleFocus() {
    setDirtyInput(true)
  }

  function handleBlur() {
    if (dirtyInput && isInvalid) {
      setLocalValue(value)

      setDirtyInput(false)
      setIsInvalid(false)
    }
  }

  return (
    <>
      {isInvalid && <span className={classes.notification}>*</span>}
      <InlineEditable
        className={clsx(isInvalid && classes.fieldValue__invalid)}
        value={localValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        {...props}
      />
    </>
  )
}

export function FieldKeyStatic({ children }) {
  return <span className={classes.fieldKey__static}>{children}</span>
}
